import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { PlayCircle } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function TrainingWelcome() {
  const { user } = useAuth();
  const nav = useNavigate();
  const key = user ? `hg-training-seen-${user.user_id}` : null;
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (key && !localStorage.getItem(key)) setOpen(true);
  }, [key]);
  const close = (watch) => {
    localStorage.setItem(key, "1");
    setOpen(false);
    if (watch) nav("/app/training");
  };
  return <Dialog open={open} onOpenChange={(o) => { if (!o) close(false); }}>
    <DialogContent data-testid="training-welcome" className="w-[calc(100%-2rem)] max-w-md rounded-lg">
      <DialogHeader>
        <div className="eyebrow text-accent">Welcome to HaulGuard</div>
        <DialogTitle className="font-display font-black text-2xl">New here? Watch two short videos.</DialogTitle>
        <DialogDescription>
          See how to set up your first load, then add a vehicle by scanning its VIN. Each takes about a minute, with captions. You can find them any time under Training.
        </DialogDescription>
      </DialogHeader>
      <div className="flex flex-col sm:flex-row gap-2 mt-2">
        <button onClick={() => close(true)} data-testid="training-welcome-watch" className="btn-amber flex-1"><PlayCircle size={18} weight="bold"/> Watch now</button>
        <button onClick={() => close(false)} data-testid="training-welcome-later" className="btn-dark flex-1">Maybe later</button>
      </div>
    </DialogContent>
  </Dialog>;
}
